module.exports = __webpack_public_path__ + "img/kehu_duoduomaicai.5311953b.png";